var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpensesTabs',{attrs:{"tab":'Claims'},on:{"tab":function($event){return _vm.onTabChange($event)}}}),(_vm.isList)?_c('ListClaims',{attrs:{"color":_vm.color,"currencies":_vm.currencies},on:{"create-claim":function($event){return _vm.onCreateClaim()},"row-click":function($event){return _vm.onRowClick($event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }